import { render, staticRenderFns } from "./IncidentTable.vue?vue&type=template&id=c89f3ea2&scoped=true"
import script from "./IncidentTable.vue?vue&type=script&lang=js"
export * from "./IncidentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89f3ea2",
  null
  
)

export default component.exports